module.exports = __webpack_public_path__ + "static/media/goliath-grouper.0c96ac3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/goliath-grouper.png
// module id = 316
// module chunks = 0